module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/buttons.component.scss
// module id = ./src/app/features/buttons/buttons.component.scss
// module chunks = main